import { RawTextCell } from '@/components/Table/components/Cell'
import { Flex } from '@chakra-ui/react'
import { createColumnHelper } from '@tanstack/react-table'
import React from 'react'
import { MdDeleteOutline, MdOutlineCheckCircle } from 'react-icons/md'
import { SystemVariableType } from '.'
import { FilterType } from '@/components/Table/components/Filter/TableFilter'

const getSystemVariableTableColumns = ({ type, handleDelete, handleActivate }) => {
  const columnHelper = createColumnHelper()

  const showDescription = [SystemVariableType.HS_CODE].includes(type)

  const columns = [
    columnHelper.display({
      id: 'action',
      size: 100,
      enableHiding: false,
      enableColumnFilter: false,
      cell: ({ row: { original } }) => {
        return (
          <>
            {original?.status === 'active' && (
              <Flex _hover={{ cursor: 'pointer' }} color="gray.400" justifyContent={'center'} w="100%">
                <MdDeleteOutline
                  size={24}
                  onClick={(e) => {
                    e.stopPropagation()
                    handleDelete(original._id)
                  }}
                />
              </Flex>
            )}
            {original?.status === 'inactive' && (
              <Flex _hover={{ cursor: 'pointer' }} color="green.400" justifyContent={'center'} w="100%">
                <MdOutlineCheckCircle
                  size={24}
                  onClick={(e) => {
                    e.stopPropagation()
                    handleActivate(original._id)
                  }}
                />
              </Flex>
            )}
          </>
        )
      },
    }),
    columnHelper.accessor('code', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('name', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('status', {
      meta: {
        filterVariant: FilterType.MULTI_SELECT,
        filterOptions: [
          { label: 'Active', value: 'active' },
          { label: 'Inactive', value: 'inactive' },
        ],
      },
    }),
  ]

  if (showDescription) {
    columns.push(
      columnHelper.accessor('description', {
        cell: RawTextCell,
      })
    )
    columns.push(
      columnHelper.accessor('descriptionZh', {
        cell: RawTextCell,
      })
    )
  }

  return columns
}

export default getSystemVariableTableColumns
